<template>

    <div id="order-price-section">
        <div class="container-new" style="text-align: left; overflow: visible; height: 195px;">
            <div class="order-right-info">
                <div class="order-price">
                    <h2>Koszt dostawy:</h2>
                    <h2>{{deliveryCost}} zł</h2>
                    <p>
                        <b>Koszt dostawy zawiera:</b><br>
                        <span>✓</span> wniesienie<br>
                        <span>✓</span> rozpakowanie<br>
                        <span>✓</span> ustawienie<br>
                        <span>✓</span> drobny montaż<a href="#" data-tooltip="Dokonanie drobnego montażu mebli w postaci : przykręcenia okuć mebla, przykręcenia boczków wersalek, narożników i foteli (z wyłączeniem finki oraz mebli w przypadku których jest potrzebna ingerencja w tapicerkę), montażu podnóżek, nóżek, stopek, listew ozdobnych do kanap i narożników, montaż kanap typu DL, montaż wezgłowia do łóżek typu RELAX, montaż zaczepów do narożników i łączenie elementów narożnika w całość. Drobny montaż nie obejmuje demontażu mebla w celu wniesienia do lokalu Klienta. Usługa drobnego montażu obejmuje powyższy zakres prac, przy założeniu, iż czas jej realizacji nie powinien zająć pracownikom więcej niż 15 minut na pojedynczy mebel.">&nbsp;[?]</a><br>
                        <span>✓</span> wyrzucenie opakowań
                    </p>

                    <p v-show="showCostInput === true"><input v-model="manualDeliveryCost" type="text" style="border: solid 1px #ddd; padding: 4px;" />
                        <span class="cpointer" v-on:click="changeCost()">OK</span></p>
                </div>
                <p v-show="deliveryCostError" class="error-message">Nie udało się przeliczyć kosztów dostawy. Skontaktuj się z działem Call Center pod adresem mailowym callcenter@dts.pl.</p>
            </div>
            <p style="margin-top: 60px; text-align: right;cursor: pointer;" v-show="false" v-on:click="showChangeCostInput()">Zmień koszt</p>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'orderPriceSection',
        props: ['delivery', 'step'],

        data () {
            return {
                manualDeliveryCost: '',
                deliveryCostError: false,
                showCostInput: false
            }
        },

        methods: {
            changeCost: function() {
                var cost = parseFloat(this.manualDeliveryCost);
                if (isNaN(cost) === true) {
                    alert('Wpisz liczbę');
                    return;
                }
                this.$emit('changeMannualyDelivCost', cost);
            },
            showChangeCostInput: function() {
                this.showCostInput = true;
            }
        },

        computed: {
            deliveryCost: function() {
                if (this.delivery.cost == '' || !_.isNumber(parseFloat(this.delivery.cost))) {
                    return "0.00";
                }
                var c = parseFloat(this.delivery.cost);
                return c.toFixed(2);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// OrderPrice.vue?6e9d78be